// extracted by mini-css-extract-plugin
export default {"RequestAccessSuccessPage":"styles_RequestAccessSuccessPage__Tja-2","container":"styles_container__+JiQU"};